import {CHANGE_LANG, ChangeLanguageAction} from '../actions/lang.action';
import { createSelector } from '@ngrx/store';



// export const userLogin = createSelector(
//     getUserFeatureState,
//     state => state.UserLogin
// );

// export const getUser = createSelector(
//     getUserFeatureState,
//     state => state.currentUser
// );


export function reducer(lang: 'de' | 'en' | 'it' | 'fr' = 'it', action: ChangeLanguageAction): 'de' | 'en' | 'it' | 'fr' {

  switch (action.type) {

    case CHANGE_LANG: {
      return action.payload;
    }

    default : {
      return lang;
    }
  }

}



// WEBPACK FOOTER //
// C:/Users/majli/reposales365/sale365/src/app/reducers/language.reducer.ts